import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import { ApiHeaderWithToken } from '../common/apisHeaders.js';

const BASE = `${process.env.REACT_APP_BACKEND_API}/patient-phi`;

export const createPatientPHI = createAsyncThunk(
  'createPatientPHI',
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(BASE, data, ApiHeaderWithToken());
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  },
);

export const getAllPatientPHI = createAsyncThunk(
  'getAllPatientPHI',
  async (params, { rejectWithValue }) => {
    try {
      const response = await axios.get(BASE, {
        params,
        ...ApiHeaderWithToken(),
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  },
);

export const getPatientPHIById = createAsyncThunk(
  'getPatientPHIById',
  async (id, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${BASE}/${id}`, ApiHeaderWithToken());
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  },
);

export const updatePatientPHI = createAsyncThunk(
  'updatePatientPHI',
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await axios.put(`${BASE}/${id}`, data, ApiHeaderWithToken());
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  },
);

export const deletePatientPHI = createAsyncThunk(
  'deletePatientPHI',
  async (id, { rejectWithValue }) => {
    try {
      const response = await axios.delete(`${BASE}/${id}`, ApiHeaderWithToken());
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  },
);

export const patientPHISliceDetails = createSlice({
  name: 'patientPHISliceDetails',
  initialState: {
    records: [],
    record: {},
    totalCount: 0,
    loading: false,
    error: null,
  },
  reducers: {
    clearPatientPHI: (state) => {
      state.record = {};
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createPatientPHI.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createPatientPHI.fulfilled, (state) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(createPatientPHI.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(getAllPatientPHI.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllPatientPHI.fulfilled, (state, action) => {
        state.loading = false;
        state.records = action.payload.data;
        state.totalCount = action.payload.totalCount;
        state.error = null;
      })
      .addCase(getAllPatientPHI.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(getPatientPHIById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getPatientPHIById.fulfilled, (state, action) => {
        state.loading = false;
        state.record = action.payload.data;
        state.error = null;
      })
      .addCase(getPatientPHIById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(updatePatientPHI.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updatePatientPHI.fulfilled, (state) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(updatePatientPHI.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(deletePatientPHI.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deletePatientPHI.fulfilled, (state) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(deletePatientPHI.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearPatientPHI } = patientPHISliceDetails.actions;
export default patientPHISliceDetails.reducer;
